<script lang="ts">
	import { resolve } from '$app/paths';
	import { onMount, onDestroy } from 'svelte';
	import { ROUTES } from '#lib/ui/routes.ts';

	let isOpen = $state(false);
	let menuButton: HTMLElement;

	function handleClickOutside(event: MouseEvent) {
		if (menuButton && !menuButton.contains(event.target as Node)) {
			isOpen = false;
		}
	}

	onMount(() => {
		if (typeof document === 'undefined') return;
		document.addEventListener('click', handleClickOutside);
	});

	onDestroy(() => {
		if (typeof document === 'undefined') return;
		document.removeEventListener('click', handleClickOutside);
	});
</script>

<div class="menu-container">
	<button
		bind:this={menuButton}
		onclick={() => (isOpen = !isOpen)}
		class="menu-button"
		aria-label="Menu"
		aria-expanded={isOpen}
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			width="100%"
			height="100%"
			class="menu-icon"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M4 6h16M4 12h16M4 18h16"
			/>
		</svg>
	</button>
	{#if isOpen}
		<ul class="menu-dropdown">
			<li><a href={resolve(ROUTES.HOME)}>Home</a></li>
			<li><a href={resolve(ROUTES.RULES)}>Rules</a></li>
			<li><a href={resolve(ROUTES.SETTINGS)}>Settings</a></li>
			<li><a href={resolve(ROUTES.ABOUT)}>About</a></li>
		</ul>
	{/if}
</div>

<style>
	.menu-container {
		position: relative;
		z-index: 10;
		display: inline-block; /* Add this to ensure the container takes proper space */
	}

	.menu-button {
		width: 1.75rem;
		height: 1.75rem;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: transparent;
		border: none;
		cursor: pointer;
		padding: 0;
	}

	.menu-icon {
		stroke: currentColor;
	}

	.menu-dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		width: 13rem;
		margin-top: 0.5rem;
		padding: 0.5rem;
		background-color: var(--black-8);
		border-radius: 0.5rem;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
		list-style-type: none;
	}

	.menu-dropdown li {
		margin: 0;
		padding: 0;
	}

	.menu-dropdown a {
		display: block;
		padding: 0.75rem 1rem;
		color: inherit;
		text-decoration: none;
		border-radius: 0.25rem;
		transition: background-color 0.2s;
	}

	.menu-dropdown a:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}
</style>
